module.exports = __webpack_public_path__ + "img/mandarin-1.cea43637.png";